import type { FC } from 'react';
import loadable from '@loadable/component';
import { Layout } from '../../components/layout/Layout';
import { useIsMobile } from '../../hooks/use-is-mobile';
import { AddCategorySeo } from '../show/AddCategorySeo';
import { SearchSkeletons } from './components/skeletons/SearchSkeletons';
import type { CategoryInfo } from '../show/api/getContentData';

const CategorySearch = loadable(() => import('./CategorySearch'));

interface CategorySearchProps {
    categoryInfo?: CategoryInfo;
}

const CategorySearchLazy: FC<CategorySearchProps> = ({ categoryInfo }) => {
    const isMobile = useIsMobile();

    return (
        <Layout stickyNavigation={isMobile}>
            <AddCategorySeo categoryInfo={categoryInfo}>
                <CategorySearch categoryInfo={categoryInfo} fallback={<SearchSkeletons />} />
            </AddCategorySeo>
        </Layout>
    );
};

CategorySearchLazy.defaultProps = {
    categoryInfo: undefined,
};

export { CategorySearchLazy };
